export class Motifs {
 public id: string;
  public name: string;
  public nameArabic: string;
  public color: string;

  constructor(other?: Partial<Motifs>) {
    this.id = other?.id ?? '';
    this.name = other?.name ?? '';
    this.nameArabic = other?.nameArabic ?? '';
    this.color = other?.color ?? '';
  }

  public static fromResponse(res: any): Motifs {
    return new Motifs({
      id: res.id,
      name: res.text,
      nameArabic: res.arabicLabel,
      color: res.color,
    });
  }
}